module.exports = __webpack_public_path__ + "static/case-aarp-5580a78a39282467d16ca0476454963f.jpg";